import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/catalog/import')({
  component: () => <Outlet />,
})
